/**
 * @salonomy/api-client — the typed client WS2 (console) and WS4 (mobile) consume.
 *
 * `paths` in ./generated/schema.d.ts is produced from apps/api/openapi.json by
 * `pnpm --filter @salonomy/api-client generate` (run on every deploy). createSalonomyClient
 * wraps openapi-fetch so every request/response is typed straight from the OpenAPI contract.
 */
import createFetchClient, { type Client } from 'openapi-fetch';
import type { paths } from './generated/schema.js';

export type SalonomyPaths = paths;
export type SalonomyClient = Client<paths>;

export interface SalonomyClientOptions {
  /** API origin, e.g. https://api.salonomy.com */
  baseUrl: string;
  /** Public-API personal access token (Authorization: Bearer slm_…). Omit for cookie sessions. */
  token?: string;
  /** Send cookies (first-party apps). Defaults to true. */
  credentials?: RequestCredentials;
  fetch?: typeof fetch;
}

export function createSalonomyClient(options: SalonomyClientOptions): SalonomyClient {
  return createFetchClient<paths>({
    baseUrl: options.baseUrl.replace(/\/$/, ''),
    credentials: options.credentials ?? 'include',
    headers: options.token ? { Authorization: `Bearer ${options.token}` } : undefined,
    ...(options.fetch ? { fetch: options.fetch } : {}),
  });
}

// Re-export the domain types/schemas so consumers have one import for both.
export * from '@salonomy/types';
